import { useState, useEffect } from 'react';

export type OsOptions =
  | 'macOS'
  | 'Windows'
  | 'Linux'
  | 'Android'
  | 'iOS'
  | 'Unknown';

export const useGetOS = () => {
  const [os, setOS] = useState<OsOptions>('Unknown');

  useEffect(() => {
    const userAgent = window.navigator.userAgent;

    if (/Windows/i.test(userAgent)) {
      setOS('Windows');
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      setOS('iOS');
    } else if (/Mac OS X/i.test(userAgent)) {
      setOS('macOS');
    } else if (/Android/i.test(userAgent)) {
      setOS('Android');
    } else if (/Linux/i.test(userAgent)) {
      setOS('Linux');
    } else {
      setOS('Unknown');
    }
  }, []);

  return os;
};
